// We do not have fine grain control over the organisation invited users, hence we have some manual overrides here

export const HIDE_ADD_AGENT_BUTTON_FOR_PRODUCT_NAMES = ['RT7 - Member Account'];

// Some custom organisation manage their own billing, for others we want to hide it
export const SELF_MANAGING_CUSTOM_ORGANISATIONS = ['6641dd2aec73b9c9e4271b25'];
